import { api } from '@/api/client';

import type { Paging } from './common';

export interface SupplierProductMapping {
  id: string;
  supplier_id: string;
  supplier_name?: string | null;
  supplier_product_name_raw: string;
  supplier_product_name_norm: string;
  product_id: string;
  product_name?: string | null;
  confidence: string;
  times_used: number;
  last_used_at?: string | null;
  created_at?: string | null;
}

export interface SupplierProductMappingsFilters {
  [key: string]: string | number | boolean | undefined;
  supplier_id?: string;
  product_id?: string;
  search?: string;
  page?: number;
  page_size?: number;
  limit?: number;
  offset?: number;
}

export interface SupplierProductMappingsResponse {
  request_id: string;
  items: SupplierProductMapping[];
  paging: Paging;
}

export interface UpsertSupplierProductMappingRequest {
  supplier_id: string;
  supplier_product_name: string;
  product_id: string;
  confidence?: string;
}

export interface SupplierProductMappingUpsertResponse {
  request_id: string;
  item: SupplierProductMapping;
}

export interface SupplierProductMappingDeleteResponse {
  request_id: string;
  success: boolean;
}

export const createStockSupplierProductMappingsApi = () => ({
  list: (filters: SupplierProductMappingsFilters = {}): Promise<SupplierProductMappingsResponse> =>
    api.webAdmin.get('/stock/supplier-product-mappings', { params: filters }),

  upsert: (
    data: UpsertSupplierProductMappingRequest,
  ): Promise<SupplierProductMappingUpsertResponse> =>
    api.webAdmin.post('/stock/supplier-product-mappings', data),

  delete: (id: string): Promise<SupplierProductMappingDeleteResponse> =>
    api.webAdmin.delete(`/stock/supplier-product-mappings/${id}`),
});
